"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Hotel = _interopRequireDefault(require("@material-ui/icons/Hotel"));

var _Flight = _interopRequireDefault(require("@material-ui/icons/Flight"));

var _People = _interopRequireDefault(require("@material-ui/icons/People"));

var _BeachAccess = _interopRequireDefault(require("@material-ui/icons/BeachAccess"));

var _Whatshot = _interopRequireDefault(require("@material-ui/icons/Whatshot"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));

var _StarHalf = _interopRequireDefault(require("@material-ui/icons/StarHalf"));

var _StarBorder = _interopRequireDefault(require("@material-ui/icons/StarBorder"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _Notifications = _interopRequireDefault(require("@material-ui/icons/Notifications"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _DateRange = _interopRequireDefault(require("@material-ui/icons/DateRange"));

var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Facebook = _interopRequireDefault(require("@material-ui/icons/Facebook"));

var _Twitter = _interopRequireDefault(require("@material-ui/icons/Twitter"));

var _Instagram = _interopRequireDefault(require("@material-ui/icons/Instagram"));

var _YouTube = _interopRequireDefault(require("@material-ui/icons/YouTube"));

var _LinkedIn = _interopRequireDefault(require("@material-ui/icons/LinkedIn"));

var _Pinterest = _interopRequireDefault(require("@material-ui/icons/Pinterest"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

var _Language = _interopRequireDefault(require("@material-ui/icons/Language"));

var _Public = _interopRequireDefault(require("@material-ui/icons/Public"));

var _MonetizationOn = _interopRequireDefault(require("@material-ui/icons/MonetizationOn"));

var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _AccountBox = _interopRequireDefault(require("@material-ui/icons/AccountBox"));

var _FeaturedPlayList = _interopRequireDefault(require("@material-ui/icons/FeaturedPlayList"));

var _LibraryBooks = _interopRequireDefault(require("@material-ui/icons/LibraryBooks"));

var _CreditCard = _interopRequireDefault(require("@material-ui/icons/CreditCard"));

var _AssignmentTurnedIn = _interopRequireDefault(require("@material-ui/icons/AssignmentTurnedIn"));

var _Money = _interopRequireDefault(require("@material-ui/icons/Money"));

var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));

var _PlayCircleOutline = _interopRequireDefault(require("@material-ui/icons/PlayCircleOutline"));

var _PauseCircleOutline = _interopRequireDefault(require("@material-ui/icons/PauseCircleOutline"));

var _Home = _interopRequireDefault(require("@material-ui/icons/Home"));

var _CollectionsBookmark = _interopRequireDefault(require("@material-ui/icons/CollectionsBookmark"));

var _PlaylistAddCheck = _interopRequireDefault(require("@material-ui/icons/PlaylistAddCheck"));

var _FlightTakeoff = _interopRequireDefault(require("@material-ui/icons/FlightTakeoff"));

var _Forum = _interopRequireDefault(require("@material-ui/icons/Forum"));

var _Person = _interopRequireDefault(require("@material-ui/icons/Person"));

var _DirectionsBoat = _interopRequireDefault(require("@material-ui/icons/DirectionsBoat"));

var _DirectionsBus = _interopRequireDefault(require("@material-ui/icons/DirectionsBus"));

var _Train = _interopRequireDefault(require("@material-ui/icons/Train"));

var _DriveEta = _interopRequireDefault(require("@material-ui/icons/DriveEta"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _SwapHoriz = _interopRequireDefault(require("@material-ui/icons/SwapHoriz"));

var _FiberManualRecord = _interopRequireDefault(require("@material-ui/icons/FiberManualRecord"));

var _ArrowRightAlt = _interopRequireDefault(require("@material-ui/icons/ArrowRightAlt"));

var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));

var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _AttachFile = _interopRequireDefault(require("@material-ui/icons/AttachFile"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Room = _interopRequireDefault(require("@material-ui/icons/Room"));

var _PanoramaFishEye = _interopRequireDefault(require("@material-ui/icons/PanoramaFishEye"));

var _TripOrigin = _interopRequireDefault(require("@material-ui/icons/TripOrigin"));

var _Shuffle = _interopRequireDefault(require("@material-ui/icons/Shuffle"));

var _TransferWithinAStation = _interopRequireDefault(require("@material-ui/icons/TransferWithinAStation"));

var _VerifiedUser = _interopRequireDefault(require("@material-ui/icons/VerifiedUser"));

var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));

var _ChildCare = _interopRequireDefault(require("@material-ui/icons/ChildCare"));

var _ChildFriendly = _interopRequireDefault(require("@material-ui/icons/ChildFriendly"));

var _PermIdentity = _interopRequireDefault(require("@material-ui/icons/PermIdentity"));

var _History = _interopRequireDefault(require("@material-ui/icons/History"));

var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));

var _DescriptionOutlined = _interopRequireDefault(require("@material-ui/icons/DescriptionOutlined"));

var _RecentActorsOutlined = _interopRequireDefault(require("@material-ui/icons/RecentActorsOutlined"));

var _CallMade = _interopRequireDefault(require("@material-ui/icons/CallMade"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));

var _Apartment = _interopRequireDefault(require("@material-ui/icons/Apartment"));

var _Map = _interopRequireDefault(require("@material-ui/icons/Map"));

var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));

var _TrendingUp = _interopRequireDefault(require("@material-ui/icons/TrendingUp"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _LocalGasStation = _interopRequireDefault(require("@material-ui/icons/LocalGasStation"));

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _GetApp = _interopRequireDefault(require("@material-ui/icons/GetApp"));

var _WorkOff = _interopRequireDefault(require("@material-ui/icons/WorkOff"));

var _Accessible = _interopRequireDefault(require("@material-ui/icons/Accessible"));

var _island_transfer = _interopRequireDefault(require("./statics/island_transfer"));

var _change_currency = _interopRequireDefault(require("./statics/change_currency"));

var _infant = _interopRequireDefault(require("./statics/infant"));

var _arrow_up = _interopRequireDefault(require("./statics/arrow_up"));

var _FlightReverseIcon = _interopRequireDefault(require("./statics/FlightReverseIcon"));

var _cancel = _interopRequireDefault(require("./statics/cancel"));

var _hotel = _interopRequireDefault(require("./statics/hotel"));

var _default = {
  Menu: _Menu.default,
  Person: _Person.default,
  ArrowBackIos: _ArrowBackIos.default,
  ArrowForward: _ArrowForward.default,
  AccountBox: _AccountBox.default,
  FeaturedPlayList: _FeaturedPlayList.default,
  LibraryBooks: _LibraryBooks.default,
  CreditCard: _CreditCard.default,
  AssignmentTurnedIn: _AssignmentTurnedIn.default,
  Money: _Money.default,
  AttachMoney: _AttachMoney.default,
  HotelIcon: _Hotel.default,
  FlightIcon: _Flight.default,
  PeopleIcon: _People.default,
  BeachAccessIcon: _BeachAccess.default,
  WhatshotIcon: _Whatshot.default,
  DeleteIcon: _Delete.default,
  LocationOnIcon: _LocationOn.default,
  ChevronRightIcon: _ChevronRight.default,
  ChevronLeftIcon: _ChevronLeft.default,
  StarIcon: _Star.default,
  StarHalfIcon: _StarHalf.default,
  StarBorderIcon: _StarBorder.default,
  CloseIcon: _Close.default,
  InfoOutlinedIcon: _InfoOutlined.default,
  CheckIcon: _Check.default,
  NotificationsIcon: _Notifications.default,
  AddIcon: _Add.default,
  RemoveIcon: _Remove.default,
  ErrorIcon: _Error.default,
  DateRangeIcon: _DateRange.default,
  AccessTimeIcon: _AccessTime.default,
  ExpandLessIcon: _ExpandLess.default,
  ExpandMoreIcon: _ExpandMore.default,
  FacebookIcon: _Facebook.default,
  TwitterIcon: _Twitter.default,
  InstagramIcon: _Instagram.default,
  YouTubeIcon: _YouTube.default,
  LinkedInIcon: _LinkedIn.default,
  PinterestIcon: _Pinterest.default,
  KeyboardArrowLeftIcon: _KeyboardArrowLeft.default,
  ArrowBackIcon: _ArrowBack.default,
  LanguageIcon: _Language.default,
  PublicIcon: _Public.default,
  MonetizationOnIcon: _MonetizationOn.default,
  AccountCircle: _AccountCircle.default,
  PlayCircleOutlineIcon: _PlayCircleOutline.default,
  PauseCircleOutlineIcon: _PauseCircleOutline.default,
  HomeIcon: _Home.default,
  CollectionsBookmarkIcon: _CollectionsBookmark.default,
  PlaylistAddCheckIcon: _PlaylistAddCheck.default,
  FlightTakeoffIcon: _FlightTakeoff.default,
  ForumIcon: _Forum.default,
  DirectionsBoat: _DirectionsBoat.default,
  DirectionsBus: _DirectionsBus.default,
  Train: _Train.default,
  DriveEta: _DriveEta.default,
  EditIcon: _Edit.default,
  SwapHorizIcon: _SwapHoriz.default,
  FiberManualRecordIcon: _FiberManualRecord.default,
  ArrowRightAltIcon: _ArrowRightAlt.default,
  Sort: _Sort.default,
  FilterList: _FilterList.default,
  Search: _Search.default,
  AttachFileIcon: _AttachFile.default,
  CheckCircleIcon: _CheckCircle.default,
  RoomIcon: _Room.default,
  PanoramaFishEyeIcon: _PanoramaFishEye.default,
  TripOriginIcon: _TripOrigin.default,
  ShuffleIcon: _Shuffle.default,
  TransferWithinAStationIcon: _TransferWithinAStation.default,
  VerifiedUserIcon: _VerifiedUser.default,
  ShoppingCartIcon: _ShoppingCart.default,
  ChildCareIcon: _ChildCare.default,
  ChildFriendlyIcon: _ChildFriendly.default,
  PermIdentityIcon: _PermIdentity.default,
  History: _History.default,
  CheckCircleOutlineIcon: _CheckCircleOutline.default,
  DescriptionOutlinedIcon: _DescriptionOutlined.default,
  RecentActorsOutlinedIcon: _RecentActorsOutlined.default,
  CallMadeIcon: _CallMade.default,
  ArrowDropDownIcon: _ArrowDropDown.default,
  ApartmentIcon: _Apartment.default,
  IslandTransfer: _island_transfer.default,
  MapIcon: _Map.default,
  HighlightOff: _HighlightOff.default,
  TrendingUpIcon: _TrendingUp.default,
  VisibilityOffIcon: _VisibilityOff.default,
  VisibilityIcon: _Visibility.default,
  LocalGasStationIcon: _LocalGasStation.default,
  BlockIcon: _Block.default,
  GetAppIcon: _GetApp.default,
  ChangeCurrency: _change_currency.default,
  AccessibleIcon: _Accessible.default,
  InfantIcon: _infant.default,
  ArrowUp: _arrow_up.default,
  FlightReverseIcon: _FlightReverseIcon.default,
  WorkOffIcon: _WorkOff.default,
  CancelIcon: _cancel.default,
  NewHotelIcon: _hotel.default
};
exports.default = _default;